let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d9d1U")).then(() => parcelRequire('cuCTa'));